const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "生成式AI發展機會：以人為本、跨域創新",
      "author": "蘇孟宗",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=17&domain=82&sld_preid=7606",
      "image": `${require('assets/images/home/news-1.jpg')}`,
      "time": "2023/06/30"
    },
    {
      "title": "AI總論: 人工智慧產業技術趨勢概論勢",
      "author": "陳右怡",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=17&domain=82&sld_preid=7626",
      "image": `${require('assets/images/home/news-2.jpg')}`,
      "time": "2024/06/30"
    },
    {
      "title": "各國超級電腦算力and Project TAME介紹",
      "author": "石立康",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=17&domain=82&sld_preid=7698",
      "image": `${require('assets/images/home/news-3.jpg')}`,
      "time": "2024/09/12"
    },
  ]
}

export default latestArticle;